import EventEmitter from 'events';
import imaEvents from './imaEvents';
export default class ImaApi extends EventEmitter {
    constructor(google) {
        super();
        this.google = google;
    }
    static promisfiedAdRequestTimeout() {
        return new Promise((resolve, reject) => {
            setTimeout(() => reject(new Error('AdManager took to long to load.')), 5000);
        });
    }
    getAdContainer(containerElement, videoElement) {
        if (!(containerElement && videoElement)) {
            throw new Error('Cannot get AdDisplayContainer without a containerElement and videoElement.');
        }
        return this._getAdDisplayContainer(containerElement, videoElement);
    }
    async getAdsManager(url, adContainer, videoElement) {
        if (!(url && adContainer && videoElement)) {
            throw new Error('Cannot get AdsManager without a url, adContainer or videoElement.');
        }
        const managerLoadedEvent = await this._getAdsManager(url, adContainer);
        const adsRenderingSettings = new this.google.ima.AdsRenderingSettings();
        adsRenderingSettings.uiElements = [];
        return managerLoadedEvent.getAdsManager(videoElement, adsRenderingSettings);
    }
    _getAdsManager(adTagUrl, adContainer) {
        const requestPromise = this._requestAd(adTagUrl, adContainer);
        this.emit(imaEvents.AdEvent.AD_REQUESTED);
        const timeoutPromise = ImaApi.promisfiedAdRequestTimeout();
        return Promise.race([requestPromise, timeoutPromise]);
    }
    _getAdDisplayContainer(containerElement, videoElement) {
        const adContainer = new this.google.ima.AdDisplayContainer(containerElement, videoElement);
        adContainer.initialize();
        return adContainer;
    }
    _requestAd(url, adContainer) {
        const adsLoader = new this.google.ima.AdsLoader(adContainer);
        const managerRequestPromise = this._promisfyAdManagerLoad(adsLoader);
        const adsRequest = new this.google.ima.AdsRequest();
        adsRequest.adTagUrl = url;
        adsLoader.requestAds(adsRequest);
        return managerRequestPromise;
    }
    _promisfyAdManagerLoad(adsLoader) {
        return new Promise((resolve, reject) => {
            adsLoader.addEventListener(this.google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, resolve, false);
            adsLoader.addEventListener(this.google.ima.AdErrorEvent.Type.AD_ERROR, reject, false);
        });
    }
}
